module.exports = __webpack_public_path__ + "img/remind-icon1.de387371.png";